import axios from 'axios';
import { store } from './Redux/store';

const MAX_RETRIES = 3;

class VeracityAPI {
  constructor(options) {
    this.authToken = localStorage.getItem("authToken") ?? "";
    this.refreshToken = localStorage.getItem("refreshToken") ?? "";

    const schema = "https";
    let useHostname = "api.platform.veracitytrustnetwork.com";
    if(document.location.hostname === "qa.platform.veracitytrustnetwork.com"){
      useHostname = "qa-api.platform.veracitytrustnetwork.com";     
    };

    if(document.location.hostname === "localhost"){
      useHostname = "dev-api.platform.veracitytrustnetwork.com";
      //useHostname = "qa-api.platform.veracitytrustnetwork.com";
    }

    this.config = Object.assign({
      schema,
      hostname: useHostname,
      apikey: "SERVERADMINKEY",
      applicationKey: "5Fj43Y9Up8fKZzNDuuSG59c48PEACY4u"
    }, options);

    this.instance = axios.create({
      baseURL: `${this.config.schema}://${this.config.hostname}`,
      timeout: 60000,
      headers: { "VeracityID": this.config.apikey },
      validateStatus: (status) => status === 200,
    });
  }

  async requestWithRetry(method, endpoint, data, headers, querystringObj, attempt = 0) {
    while(this.isRefreshing && endpoint != "/user/refresh"){
      await new Promise(res => setTimeout(res, 200));
    }
    if (this.authToken !== "") headers['Authorization'] = this.authToken;
    const afpEndpoints = ['2.0/', '3.0/'];
    if (afpEndpoints.some(e => endpoint.includes(e))) {
			querystringObj['url'] = endpoint;
			endpoint = `/afp/${this.getAFPWebsiteId()}`
		}
    const url = `${endpoint}?${new URLSearchParams({ ...querystringObj, oa_clientKey: this.config.applicationKey })}`;

    try {
      const response = await this.instance({ method, url, data, headers });
      return response.data;
    } catch (error) {
      const status = error.response?.status;
      if (status === 401 && attempt < MAX_RETRIES) {
        await this.tryRefreshToken();
        return this.requestWithRetry(method, endpoint, data, headers, querystringObj, attempt + 1);
      }
      if(attempt < MAX_RETRIES){
        await new Promise(res => setTimeout(res, 300 * 2 ** attempt));
        return this.requestWithRetry(method, endpoint, data, headers, querystringObj, attempt + 1);
      }
      // if ([403, 500, 502, 504].includes(status) && attempt < MAX_RETRIES) {
      //   await new Promise(res => setTimeout(res, 300 * 2 ** attempt));
      //   return this.requestWithRetry(method, endpoint, data, headers, querystringObj, attempt + 1);
      // }
      throw new Error("API request failed: " + (error.response?.data?.message || error.message));
    }
  }

  async tryRefreshToken() {
    if (!this.isRefreshing) {
      this.isRefreshing = true;
      try {
        const resp = await this.requestWithRetry('PUT', '/user/refresh', { refresh_token: this.refreshToken }, {}, {}, 0);
        this.authToken = resp.item.token;
        this.refreshToken = resp.item.refresh;
        localStorage.setItem("authToken", this.authToken);
        localStorage.setItem("refreshToken", this.refreshToken);
      } catch (error) {
        this.logout("refresh_error");
        throw error;
      } finally {
        this.isRefreshing = false;
      }
    }
  }

  logout(reason) {
    localStorage.clear();
    if (reason) localStorage.setItem("logout_reason", reason);
    document.location = "/";
  }

  async doLogin(email, password, mfa) {
    localStorage.removeItem("logout_reason");
    const sodium = window.sodium;
    const publicKey = this.ToUint8Array("Of4AejM3xsLrpQpN2PHvLpJj5q683m2JzsKiRJTDMD8=");
    const encryptedPassword = sodium.crypto_box_seal(password, publicKey);
    const encodedPassword = this.Uint8ArrayToBase64(encryptedPassword);
    const url = `/user/login?${new URLSearchParams({ oa_clientKey: this.config.applicationKey })}`
    try{
      const response = await this.instance({method:'PUT', url, data:{ email, password: encodedPassword, mfa }, headers:{} });
      this.authToken = response.data.item.token ?? "";
      this.refreshToken = response.data.item.refresh ?? "";
      localStorage.setItem("authToken", this.authToken);
      localStorage.setItem("refreshToken", this.refreshToken);      
      return response.data;
    } catch(error){ 
      const returnError =  error;
      throw returnError;
    }
   


    // return this.PUT("/user/login", { email, password: encodedPassword, mfa }, {}, "overrideNotLoggedIn").then(resp => {
    //   this.authToken = resp.item.token ?? "";
    //   this.refreshToken = resp.item.refresh ?? "";
    //   localStorage.setItem("authToken", this.authToken);
    //   localStorage.setItem("refreshToken", this.refreshToken);
    //   return resp;
    // });
  }

  ToUint8Array(base64) {
    const binaryString = atob(base64);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) bytes[i] = binaryString.charCodeAt(i);
    return bytes;
  }

  Uint8ArrayToBase64(uint8Array) {
    let binaryString = '';
    for (let i = 0; i < uint8Array.length; i++) binaryString += String.fromCharCode(uint8Array[i]);
    return btoa(binaryString);
  }

  paged = (endpoint, limit, page, querystringObj) => {
		if (this.authToken === "") {
			throw new Error("Invalid: User is not logged in");

		}

		if (typeof querystringObj === "undefined") {
			querystringObj = {};
		}

		limit = typeof limit === "undefined" ? 10 : limit;
		page = typeof page === "undefined" ? 1 : page;

		querystringObj = Object?.assign(querystringObj,
			{
				limit: parseInt(limit),
				page: parseInt(page)
			});

		const headers = {};
		if (this.authToken !== "") {
			headers['Authorization'] = this.authToken;
		}

		return this.GET(endpoint, querystringObj);
	};

  isUserLoggedIn() { return !(this.authToken === ""); }
  setWebsiteGUID(guid) { localStorage.setItem("selected_site", guid); }
  getWebsiteGUID() {
     const val = localStorage.getItem("selected_site");
     if(val === "null") return null;
     return val;
  }
  setCustomerGUID(guid) { localStorage.setItem("selected_customer", guid); }
  getCustomerGUID() {
    const val = localStorage.getItem("selected_customer");
    if(val === "null") return null;
    return val;
 }
  clearStore() { store.dispatch({ type: 'CLEAR_STORE' }); }
  handleError(error) { console.log("API Error:", error); this.logout("api_error"); }
  getAFPWebsiteId() {
    const val = localStorage.getItem("bcn-website-id");
    if(val === "null") return null;
    return val;
 }

  GET(endpoint, querystringObj, softfail = false) {
   return this.requestWithRetry('GET', endpoint, null, {}, querystringObj).catch((error) => {
      if(softfail){
          return Promise.reject("api_failed");
      } else {
        this.handleError("api_failed");        
      };
    });
  };
  POST(endpoint, data, querystringObj) { return this.requestWithRetry('POST', endpoint, data, {}, querystringObj); }
  PUT(endpoint, data, querystringObj) { return this.requestWithRetry('PUT', endpoint, data, {}, querystringObj); }
  PATCH(endpoint, data, querystringObj) { return this.requestWithRetry('PATCH', endpoint, data, {}, querystringObj); }
  DELETE(endpoint, querystringObj) { return this.requestWithRetry('DELETE', endpoint, null, {}, querystringObj); }
  HEAD(endpoint, querystringObj) { return this.requestWithRetry('HEAD', endpoint, null, {}, querystringObj); }
}

const api = new VeracityAPI();

export default api;